import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { OpfoelgningCountResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/opfoelgning-count-response';
import { OpfoelgningService, SlutopgoerelseService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { EnvironmentService } from 'src/app/environment/services/environment.service';
import { AuthService } from 'src/app/services/auth.service';
import { OpfoelgningChanged, SignalrService } from 'src/app/services/signalr.service';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SideNavigationComponent implements OnInit {
  showStatusMenuItem: boolean = false;
  showSettings: boolean = false;
  showSlutopgoerelser: boolean = false;
  showErrorDashboard: boolean = false;

  antalOpfoelgninger: number = 0;
  antalOpfoelgningerPastDeadline: number = 0;
  antalSlutopgoerelser: number = 0;

  unsubscribe$ = new Subject<void>();

  getCount$: Observable<number> = new Subject();

  constructor(
    private authService: AuthService,
    private opfoelgningService: OpfoelgningService,
    private signalR: SignalrService,
    private auth: AuthService,
    private env: EnvironmentService,
    private slutopgoerelseService: SlutopgoerelseService,
  ) {
    this.showStatusMenuItem = this.auth.isAdministrator || this.auth.isSuperuser;
    this.showSettings = this.auth.isAdministrator;
    this.showSlutopgoerelser =
      this.auth.isAdministrator || this.auth.isKundeservice || this.auth.isSuperuser || this.auth.isReadonly || this.auth.isSalg;
    this.showErrorDashboard = this.auth.isAdministrator || this.auth.isSuperuser || this.auth.isReadonly;
  }

  ngOnInit(): void {
    this.getData();
    this.signalR.opfoelgningChanged$.pipe(takeUntil(this.unsubscribe$)).subscribe((response: OpfoelgningChanged) => {
      const username = this.auth.username;
      if (!response.opfoelgning || response.opfoelgning.modifiedBy.toLowerCase() == username?.toLowerCase()) {
        this.getData();
      }
    });
  }

  getData() {
    this.opfoelgningService
      .getOpfoelgningCountsForCurrentUser({ caller: EGIS_SERVICE_CALLER })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: OpfoelgningCountResponse) => {
        this.antalOpfoelgninger = response.serviceaftaleOpfoelgningerCount + response.servicordreOpfoelgningerCount;
        this.antalOpfoelgningerPastDeadline =
          response.serviceaftaleOpfoelgningerPastDeadlineCount + response.servicordreOpfoelgningerPastDeadlineCount;
      });

    if (this.showSlutopgoerelser) {
      this.slutopgoerelseService
        .getOverdueSlutopgoerelserCount({ caller: EGIS_SERVICE_CALLER })
        .pipe(
          takeUntil(this.unsubscribe$),
          catchError((err) => {
            console.log('Failed to get slutopgoerelser count', err);
            return of(undefined);
          }),
        )
        .subscribe((response: number) => {
          this.antalSlutopgoerelser = response ?? 0;
        });
    }
  }

  logOut() {
    this.authService.logout();
  }
}
